import type { CompanyDealTodoSearchCondition } from "~/models/CompanyDealTodo";
import {
	isQueryCompleted,
	SEARCH_CONDITION_KEYS
} from "~/models/CompanyDealTodo";
import type { DealType } from "~/models/Deal";

const parseNumberValue = (value: string): number | null => {
	const number = Number(value);
	return Number.isNaN(number) ? null : number;
};

/** オブジェクトから検索条件を組み立てる */
export const normalizeSearchCondition = (
	condition: CompanyDealTodoSearchCondition
): CompanyDealTodoSearchCondition => {
	const newCondition: CompanyDealTodoSearchCondition = {};

	for (const [key, value] of Object.entries(condition)) {
		const isEmpty = value === null || value === undefined || value === "";
		const isKeySearchCondition =
			SEARCH_CONDITION_KEYS.some((k) => k === key) || key === "dealTypes[]";

		if (!isEmpty && isKeySearchCondition) {
			if (key === "page") {
				if (typeof value === "number") {
					newCondition.page = value;
				} else if (typeof value === "string") {
					const parsedNumber = parseNumberValue(value);
					if (parsedNumber !== null) newCondition.page = parsedNumber;
				}
			} else if (key === "authId") {
				if (typeof value === "number") {
					newCondition.authId = value;
				} else if (typeof value === "string") {
					const parsedNumber = parseNumberValue(value);
					if (parsedNumber !== null) newCondition.authId = parsedNumber;
				}
			} else if (key === "staffId") {
				if (typeof value === "number") {
					newCondition.staffId = value;
				} else if (typeof value === "string") {
					const parsedNumber = parseNumberValue(value);
					if (parsedNumber !== null) newCondition.staffId = parsedNumber;
				}
			} else if (key === "companyVendorId") {
				if (typeof value === "number") {
					newCondition.companyVendorId = value;
				} else if (typeof value === "string") {
					const parsedNumber = parseNumberValue(value);
					if (parsedNumber !== null)
						newCondition.companyVendorId = parsedNumber;
				}
			} else if (key === "completed") {
				if (typeof value === "string" && isQueryCompleted(value)) {
					newCondition.completed = value;
				}
			} else if (key === "dealTypes" || key === "dealTypes[]") {
				if (typeof value !== "string" && typeof value !== "number") {
					newCondition.dealTypes = value;
				} else {
					newCondition.dealTypes = [value as DealType];
				}
			} else if (
				key === "text" ||
				key === "dueDateFrom" ||
				key === "dueDateTo" ||
				key === "dealName" ||
				key === "roomNumber"
			) {
				if (typeof value === "string") {
					newCondition[key] = value;
				}
			} else if (key === "sortKey") {
				if (value === "id" || value === "dueDate") {
					newCondition.sortKey = value;
				}
			} else if (key === "sortOrder") {
				if (value === "asc" || value === "desc") {
					newCondition.sortOrder = value;
				}
			}
		}
	}

	return newCondition;
};
